import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: resolve => require.ensure([], () => resolve(require('../views/Index.vue')), 'demo1'),
    meta:{
      title:"Tiger777"
    }
  },
  {
    path:'/admin',
    name:'admin',
    component: resolve => require.ensure([], () => resolve(require('../views/Admin.vue')), 'demo1')
  },
  {
    path:'/Header',
    name:'header',
    component: resolve => require.ensure([], () => resolve(require('../views/Header.vue')), 'demo1')
  },
  {
    path:'/Footer',
    name:'footer',
    component: resolve => require.ensure([], () => resolve(require('../views/Footer.vue')), 'demo1')
  },
  {
    path:'/Teaching',
    name:'teaching',
    component: resolve => require.ensure([], () => resolve(require('../views/Teaching.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Beginner Tutorial"
    }
  },
  {
    path:'/Buy',
    name:'buy',
    component: resolve => require.ensure([], () => resolve(require('../views/Buy.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Buy"
    }
  },
  {
    path:'/Client',
    name:'client',
    component: resolve => require.ensure([], () => resolve(require('../views/Client.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Customer Services"
    }
  },
  {
    path:'/Gift',
    name:'gift',
    component: resolve => require.ensure([], () => resolve(require('../views/Gift.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Send Gifts"
    }
  },
  {
    path:'/Leader',
    name:'Leader',
    component: resolve => require.ensure([], () => resolve(require('../views/Leader.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Rankings"
    }
  },
  {
    path:'/Vip',
    name:'vip',
    component: resolve => require.ensure([], () => resolve(require('../views/Vip.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Vip"
    }
  },
  // 新增
  {
    path:'/Game',
    name:'game',
    component: resolve => require.ensure([], () => resolve(require('../views/Game.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Game"
    }
  },
  {
    path:'/Agreement',
    name:'agreement',
    component: resolve => require.ensure([], () => resolve(require('../views/Agreement.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Agreement"
    }
  },
  {
    path:'/News',
    name:'news',
    component: resolve => require.ensure([], () => resolve(require('../components/News.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Beginner-News"
    }
  },
  {
    path:'/Down',
    name:'down',
    component: resolve => require.ensure([], () => resolve(require('../views/Down.vue')), 'demo1'),
    meta:{
      title:"Tiger777-DownLoad"
    }
  },
  {
    path:'/downChoice',
    name:'downChoice',
    component: resolve => require.ensure([], () => resolve(require('../components/downChoice.vue')), 'demo1'),
    meta:{
      title:"Tiger777-DownLoad"
    }
  },
  {
    path:'/currency',
    name:'currency',
    component: resolve => require.ensure([], () => resolve(require('../components/currency.vue')), 'demo1'),
    meta:{
      title:"Tiger777-currency"
    }
  },
  {
    path:'/record',
    name:'record',
    component: resolve => require.ensure([], () => resolve(require('../components/record.vue')), 'demo1'),
    meta:{
      title:"Tiger777-Record"
    }
  },
]

const router = new VueRouter({
  // mode: 'hash',
  // base: process.env.BASE_URL,
  routes,
  // mode: 'history'
})


router.afterEach((to, from) => {
  document.title = to.meta.title //在全局后置守卫中获取路由元信息设置title
})


export default router
